/**
 * Snow Monkey Form: メールアドレスと確認用メールの一致チェック
 * （お問い合わせ・採用お問い合わせ）
 */
const FORM_IDS = ['snow-monkey-form-2218', 'snow-monkey-form-2498'] as const;

const ERROR_CLASS = 'smf-email-confirm-error';
const ERROR_VISIBLE_CLASS = 'is-visible';

function isTargetPage(): boolean {
  return (
    document.body.classList.contains('page-contact') ||
    document.body.classList.contains('page-recruit-contact') ||
    window.location.pathname.includes('contact')
  );
}

function getOrCreateErrorElement(confirmInput: HTMLInputElement): HTMLDivElement {
  const parent = confirmInput.parentNode;
  let el = parent?.querySelector<HTMLDivElement>(`.${ERROR_CLASS}`) ?? null;
  if (!el) {
    el = document.createElement('div');
    el.className = ERROR_CLASS;
    el.setAttribute('role', 'alert');
    el.textContent = 'メールアドレスが一致しません。';
    parent?.appendChild(el);
  }
  return el;
}

function getTargets(form: HTMLFormElement) {
  const emailInput = form.querySelector<HTMLInputElement>('input[name="email"]');
  const emailConfirmInput = form.querySelector<HTMLInputElement>('input[name="email-confirm"]');
  const submitButton = form.querySelector<HTMLButtonElement>('button[type="submit"]');
  return { emailInput, emailConfirmInput, submitButton };
}

function emailsMatch(a: string, b: string): boolean {
  return a.trim() === b.trim();
}

function syncState(form: HTMLFormElement): void {
  const { emailInput, emailConfirmInput, submitButton } = getTargets(form);
  const existing = form.querySelector<HTMLDivElement>(`.${ERROR_CLASS}`);

  if (!emailInput || !emailConfirmInput || !submitButton) {
    existing?.remove();
    return;
  }

  const errorEl = getOrCreateErrorElement(emailConfirmInput);
  const match = emailsMatch(emailInput.value, emailConfirmInput.value);

  if (match) {
    errorEl.classList.remove(ERROR_VISIBLE_CLASS);
    submitButton.disabled = false;
  } else {
    errorEl.classList.add(ERROR_VISIBLE_CLASS);
    submitButton.disabled = true;
  }
}

function attachForm(form: HTMLFormElement): void {
  if (form.dataset.emailConfirmBound === 'true') return;
  form.dataset.emailConfirmBound = 'true';

  form.addEventListener('input', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (t.name !== 'email' && t.name !== 'email-confirm') return;
    syncState(form);
  });

  form.addEventListener('submit', (e) => {
    const { emailInput, emailConfirmInput, submitButton } = getTargets(form);
    if (!emailInput || !emailConfirmInput || !submitButton) return;
    if (emailsMatch(emailInput.value, emailConfirmInput.value)) {
      submitButton.disabled = false;
      return;
    }
    const errorEl = getOrCreateErrorElement(emailConfirmInput);
    errorEl.classList.add(ERROR_VISIBLE_CLASS);
    submitButton.disabled = true;
    e.preventDefault();
  });

  syncState(form);
}

function initSmfEmailConfirm(): void {
  if (!isTargetPage()) return;

  for (const id of FORM_IDS) {
    const form = document.getElementById(id);
    if (form instanceof HTMLFormElement) attachForm(form);
  }
}

export function smfEmailConfirm(): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmfEmailConfirm);
  } else {
    initSmfEmailConfirm();
  }
}
